/**
 * Fime – Mobile Menu Controller
 */

const mobileToggle = document.getElementById('mobile-menu-toggle');
const mobileMenu = document.getElementById('mobile-menu');
const mobileMainPanel = document.getElementById('mobile-main-panel');
const mobileCloseBtns = document.querySelectorAll('.mobile-close');
const subTriggers = document.querySelectorAll('.mobile-submenu-trigger');
const subPanels = document.querySelectorAll('.mobile-sub-panel');
const backBtns = document.querySelectorAll('.back-btn');

function openMobileMenu() {
	if (!mobileMenu) return;

	mobileMenu.classList.remove('hidden');
	document.body.style.overflow = 'hidden';
	mobileToggle && mobileToggle.setAttribute('aria-expanded', 'true');
	mobileToggle && mobileToggle.classList.add('relative', 'z-[60]');
	document.getElementById('icon-menu-open') &&
		document.getElementById('icon-menu-open').classList.add('hidden');
	document.getElementById('icon-menu-close') &&
		document.getElementById('icon-menu-close').classList.remove('hidden');
}

function closeMobileMenu() {
	if (!mobileMenu) return;

	mobileMenu.classList.add('hidden');
	document.body.style.overflow = '';
	mobileToggle && mobileToggle.setAttribute('aria-expanded', 'false');
	mobileToggle && mobileToggle.classList.remove('relative', 'z-[60]');
	document.getElementById('icon-menu-open') &&
		document.getElementById('icon-menu-open').classList.remove('hidden');
	document.getElementById('icon-menu-close') &&
		document.getElementById('icon-menu-close').classList.add('hidden');
	resetMobilePanels();
}

function resetMobilePanels() {
	if (mobileMainPanel) mobileMainPanel.classList.remove('-translate-x-full');
	subPanels.forEach(function (panel) {
		panel.classList.remove('translate-x-0');
		panel.classList.add('translate-x-full');
	});
	subTriggers.forEach(function (trigger) {
		trigger.setAttribute('aria-expanded', 'false');
	});
}

mobileToggle &&
	mobileToggle.addEventListener('click', function () {
		mobileMenu.classList.contains('hidden') ? openMobileMenu() : closeMobileMenu();
	});

mobileCloseBtns.forEach(function (btn) {
	btn.addEventListener('click', closeMobileMenu);
});

subTriggers.forEach(function (trigger) {
	trigger.addEventListener('click', function () {
		const targetPanel = document.getElementById('mobile-sub-' + trigger.dataset.submenu);
		if (!targetPanel) return;
		if (mobileMainPanel) mobileMainPanel.classList.add('-translate-x-full');
		targetPanel.classList.remove('translate-x-full');
		targetPanel.classList.add('translate-x-0');
		trigger.setAttribute('aria-expanded', 'true');
	});
});

backBtns.forEach(function (btn) {
	btn.addEventListener('click', function () {
		subPanels.forEach(function (panel) {
			panel.classList.remove('translate-x-0');
			panel.classList.add('translate-x-full');
		});
		if (mobileMainPanel) mobileMainPanel.classList.remove('-translate-x-full');
		subTriggers.forEach(function (trigger) {
			trigger.setAttribute('aria-expanded', 'false');
		});
	});
});

document.addEventListener('keydown', function (e) {
	if (e.key === 'Escape' && mobileMenu && !mobileMenu.classList.contains('hidden')) {
		closeMobileMenu();
	}
});
